import { Injectable } from '@angular/core';
import { FORM_TYPE, Geo } from '../models';

@Injectable({
  providedIn: 'root'
})
export class EditDeviceService {
  private formData: any = {}; // Store form data
  private deviceLocation: any={} // Store device location
  private isSaved: boolean = false; // Store form data
  private currentDeviceId: string = ''; // Store current device id
  private formType:FORM_TYPE;
  private isToggled: boolean = false; // Store form data
  saveData(data: any) {
    this.formData = data;
  }

  getData() {
    return this.formData;
  }
  saveLocation(location: any) {
    this.deviceLocation = location; // Save device location     
    }
  getLocation() {
    return this.deviceLocation;
  }

  isFormSaved() {
    return this.isSaved;
  }
  setFormSaved(value: boolean) {
    console.log('setFormSaved', value);
    this.isSaved = value;
  }
  saveCurrentDeviceId(deviceId: string) {
    this.currentDeviceId = deviceId;
  }
  getCurrentDeviceId() {  
    return this.currentDeviceId;
  }
  getFormType() {
    return this.formType;
  }
  setFormType(formType: FORM_TYPE) {
    this.formType = formType;
  }
  setToggled(value: boolean) {
    this.isToggled = value;
  }
  getToggled() {
    return this.isToggled;
  }
}
